import {
  MASKS_PATTERNS,
  formatCpfOrCnpj,
  formatOnlyAlphanumeric,
  formatOnlyNumbers,
} from '@interco/lib-util'

const CPF_LENGTH = 11
const CNPJ_LENGTH = 14

export const CNPJ_ALPHANUMERIC_MASK = MASKS_PATTERNS.CNPJ

export const sanitizeCpfCnpj = (value: string) => {
  const normalizedValue = value.toUpperCase()
  const onlyNumbers = formatOnlyNumbers(normalizedValue)

  if (onlyNumbers.length === CPF_LENGTH) {
    return onlyNumbers
  }

  const onlyAlphanumeric = formatOnlyAlphanumeric(normalizedValue)
  return onlyAlphanumeric.slice(0, CNPJ_LENGTH)
}

export const maskCpfCnpj = (value: string) => {
  const sanitizedValue = sanitizeCpfCnpj(value)

  if (sanitizedValue.length !== CPF_LENGTH && sanitizedValue.length !== CNPJ_LENGTH) {
    return sanitizedValue
  }

  return formatCpfOrCnpj({ value: sanitizedValue })
}
